import { TweenMax } from 'gsap';
import { SplitText } from '@/assets/libs/SplitText';

export default function titleNext(el) {
  TweenMax.set(el, {
    x: 50,
    rotationX: -80,
    autoAlpha: 0,
    y: 0.6 * 60,
  });

  return el;
}
